<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 社内入库表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="入库日期" required>
                 <el-date-picker v-if="formStatus" value-format="yyyy-MM-dd HH:mm" type="datetime" size="mini" placeholder="选择日期" clearable v-model="formData.instore_date"></el-date-picker>
                 <span v-else>{{formData.instore_date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入库单号">
                <el-input v-if="formStatus" placeholder="入库单号" v-model="formData.instore_no" disabled></el-input>
                <span v-else>{{formData.instore_no}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
            <div class="detail-title"><i class="em-icon-th-list"></i> 入库明细</div>
            <el-button v-if="formStatus" type="primary" size="mini" icon="el-icon-plus" round @click="handlerShowPartDialog">添加入库明细</el-button>
            <el-button v-if="!formStatus" type="primary" size="mini" icon="el-icon-printer" round @click="printHandler">打印二维码</el-button>
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <div style="height: 100%;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="selectHandler">
              <el-table-column v-if="!formStatus" type="selection" width="40" align="center"></el-table-column>
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="样本册名称" width="150" align="center">
                <template v-slot:default="scope">
                  <el-autocomplete v-if="formStatus" style="width: 100%"
                    size="mini"
                    popper-class="my-autocomplete"
                    v-model="scope.row.product_name"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    @blur="handblur(scope)">
                  <i
                      class="el-icon-edit el-input__icon"
                      slot="suffix"
                      @click="handleIconClick">
                  </i>
                  <template slot-scope="{ item }">
                      <span>{{ item.name }}</span>
                  </template>
                  </el-autocomplete>
                  <span v-else>{{scope.row.product_name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="150" align="center"></el-table-column>
              <el-table-column label="页码" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select :disabled="scope.row.base_material_name !== '台纸'" clearable v-if="formStatus" size="mini" v-model="scope.row.page" placeholder="请选择">
                    <el-option v-for="item in scope.row.pageArr" :key="item.value"  :label="item.value" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.page}}</span>
                </template>
              </el-table-column>
              <el-table-column label="盘数" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="盘数" class="txtC"  @change="plateChange(scope.row)" v-model="scope.row.plate_number"></el-input>
                  <span v-else>{{scope.row.plate_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="每盘数量" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="数量" class="txtC" @change="numberChange(scope.row)" v-model="scope.row.number"></el-input>
                  <span v-else>{{scope.row.number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="箱数" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="盘数" class="txtC"  @change="boxChange(scope.row)" v-model="scope.row.box_number"></el-input>
                  <span v-else>{{scope.row.box_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="每箱数量" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="每箱数量" class="txtC" @change="perboxnumberChange(scope.row)" v-model="scope.row.per_box_number"></el-input>
                  <span v-else>{{scope.row.per_box_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="合计" width="60" align="center">
                <template v-slot:default="scope">
                  <span>{{scope.row.total_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="库位" width="140" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" clearable filterable size="mini" v-model="scope.row.position" placeholder="请选择" @change="positionChange(scope.row)">
                    <el-option v-for="item in positionArr" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.position_value}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-document-copy" circle @click.stop.prevent="copyDetails(scope.$index)"></el-button>
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetails(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
    <!-- 选择部件对话框 -->
    <ezz-dialog-product-part ref="productPartDialog" width="500px" :parent="this"></ezz-dialog-product-part>
    <div id='print_area' style="position: relative; z-index: -1;">
      <div style="page-break-before: auto; page-break-after:always; text-align: center;" v-for="(item,index) in arrayPrint" :key="index" >
        <div style="font-size: 80px; margin-bottom: 50px;">{{item.product_name}}</div>
        <div ref=codeItem ></div>
        <div style="font-size: 50px; margin-top: 50px;">部品：{{item.base_material_name}}</div>
        <div v-if="item.per_box_number !== '0'" style="font-size: 50px; margin-top: 30px;">数量：{{item.per_box_number}}</div>
        <div v-if="item.per_box_number === '0'" style="font-size: 50px; margin-top: 30px;">数量：{{item.number}}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import EzzDialogProductPart from '@/views/modules/store/inside/DialogPart.vue'
import QRCode from 'qrcodejs2'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      index: 0,
      formEmptyData: {
        id: '0',
        instore_no: '',
        instore_date: '',
        type: '',
        remark: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        product_id: '',
        product_name: '',
        base_material_id: '',
        base_material_name: '',
        standard: '',
        plate_number: '',
        number: '0',
        box_number: '',
        per_box_number: '0',
        total_number: '',
        position: '',
        position_value: '',
        standard_id: '',
        standard_value: '',
        remark: '',
        page: '',
        pages: [],
        pageArr: []
      },
      productList: [],
      product_check: '',
      selectedIds: [],
      arrayPrint: [],
      positionArr: [],
      standardArr: [],
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 样本册搜索
    loadProduct: function () {
      let _this = this
      _this.get(_this.$apis.getInstoreProduct, {}, function (res) {
        _this.productList = res.data.dataList
      })
    },
    querySearchAsync: function (queryString, cb) {
      this.product_check = 'false'
      var results = queryString ? this.productList.filter(this.createStateFilter(queryString)) : this.productList

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 500 * Math.random())
    },
    createStateFilter: function (queryString) {
      return (product) => {
        return product.name.indexOf(queryString) > -1
      }
    },
    handleSelect: function (item) {
      let _this = this
      _this.product_check = 'true'
      _this.formData.details[_this.index].product_name = item.name
      _this.formData.details[_this.index].product_id = item.id
      _this.formData.details[_this.index].pageArr = []
      _this.post(_this.$apis.getProductPageNoTableNumber, { ProductId: item.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          let pages = _json.pages
          for (let i = 0; i < pages.length; i++) {
            for (let j = 0; j < pages[i].split(',').length; j++) {
              _this.formData.details[_this.index].pageArr.push({ 'value': pages[i].split(',')[j] })
            }
          }
          _this.formData.details[_this.index].pageArr = _this.formData.details[_this.index].pageArr.sort(_this.compare('value'))
        }
      })
    },
    handleIconClick: function (ev) {
      console.log(ev)
    },
    handblur: function (item) {
      if (this.product_check === 'false') {
        item.row.product_name = ''
      }
      this.index = item.$index
    },
    compare: function (propertyName) {
      return function (object1, object2) {
        var value1 = object1[propertyName]
        var value2 = object2[propertyName]
        if (value2 < value1) {
          return 1
        } else if (value2 > value1) {
          return -1
        } else {
          return 0
        }
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getInstoreForm, { InstoreId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.positionArr = _json.position
          _this.standardArr = _json.standard
          if (_json.formData != null) {
            _this.formData = _json.formData
            for (let i = 0; i < _this.formData.details.length; i++) {
              if (_this.formData.details[i].standard_id === '0') {
                _this.formData.details[i].standard_id = ''
              }
              if (_this.formData.details[i].pages !== null) {
                _this.formData.details[i].pageArr = []
                for (let j = 0; j < _this.formData.details[i].pages.length; j++) {
                  for (let k = 0; k < _this.formData.details[i].pages[j].split(',').length; k++) {
                    _this.formData.details[i].pageArr.push({ 'value': _this.formData.details[i].pages[j].split(',')[k] })
                  }
                }
                _this.formData.details[i].pageArr = _this.formData.details[i].pageArr.sort(_this.compare('value'))
              }
            }
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.formData.instore_date = _this.currentTime
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    // 克重改变事件
    standardChange: function (item) {
      let resultArr = this.standardArr.filter((l) => { return l.id === item.standard_id })
      item.standard_value = resultArr[0].name
    },
    // 盘数改变事件
    plateChange: function (item) {
      item.box_number = ''
      item.per_box_number = '0'
      item.total_number = parseFloat(item.plate_number) * parseFloat(item.number)
    },
    // 数量改变事件
    numberChange: function (item) {
      item.box_number = ''
      item.per_box_number = '0'
      item.total_number = parseFloat(item.plate_number) * parseFloat(item.number)
    },
    // 箱数改变事件
    boxChange: function (item) {
      item.plate_number = ''
      item.number = '0'
      item.total_number = parseFloat(item.box_number) * parseFloat(item.per_box_number)
    },
    // 数量改变事件
    perboxnumberChange: function (item) {
      item.plate_number = ''
      item.number = '0'
      item.total_number = parseFloat(item.box_number) * parseFloat(item.per_box_number)
    },
    // 库位改变事件
    positionChange: function (item) {
      let resultArr = this.positionArr.filter((l) => { return l.id === item.position })
      item.position_value = resultArr[0].name
    },
    // 复制明细
    copyDetails: function (_index) {
      let newRow = JSON.parse(JSON.stringify(this.formData.details[_index]))
      newRow.id = ''
      newRow.store_id = ''
      this.formData.details.splice(_index, 0, newRow)
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadProduct()
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadProduct()
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    // 打开明细中部品选择对话框
    handlerShowPartDialog: function () {
      this.$refs.productPartDialog.open()
    },
    // 打印二维码
    printHandler: function () {
      let _this = this
      let _ids = _this.selectedIds.join(',')
      if (_ids.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        let content = ''
        for (var i = 0; i < _this.selectedIds.length; i++) {
          content += _this.selectedIds[i] + ','
        }
        _this.arrayPrint = _this.formData.details.filter(l => content.indexOf(l.id) > -1)
        _this.$nextTick(() => {
          _this.arrayPrint.forEach((item, index) => {
            let storeId = item.store_id
            _this.$refs.codeItem[index].innerHTML = ''
            // eslint-disable-next-line no-new
            new QRCode(_this.$refs.codeItem[index], {
              // 二维码内容
              text: storeId,
              width: 300,
              height: 300,
              // 二维码颜色
              colorDark: '#333333',
              // 二维码背景色
              colorLight: '#ffffff'
            })
          })
          setTimeout(() => {
            const style = '@page { margin-top: 200px } @media print { h1 { color: blue } img {margin: 0 auto;}}'
            _this.$print({
              printable: 'print_area',
              type: 'html',
              style: style,
              scanStyles: false
            })
          }, 200)
        })
      }
    },
    handlerDelDetails: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.details, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 多选事件
    selectHandler: function (selection) {
      this.selectedIds = []
      for (let i = 0; i < selection.length; ++i) {
        this.selectedIds.push(selection[i].id)
      }
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.instore_date === '') {
          _this.$message({
            type: 'error',
            message: '入库日期不能为空'
          })
          return false
        }

        if (_mainData.details.length === 0) {
          _this.$message({
            type: 'error',
            message: '入库明细不能为空'
          })
          return false
        }

        let bol = false
        for (let i = 0; i < _mainData.details.length; i++) {
          if (_mainData.details[i].product_name === '') {
            bol = true
          }
        }
        if (bol) {
          _this.$message({
            type: 'error',
            message: '样本册名称不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.formData.type = '1'
        _this.post(_this.$apis.saveInstore, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.viewHandler(_json.id)
              _this.parent.loadData()
            }
          }
        })
      }
    }
  },
  components: {
    EzzDialogProductPart
  }
}
</script>
